import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    CircularProgress,
    Grid,
    LinearProgress,
    makeStyles,
    TextField,
    Typography,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import { paymentMethodService } from "../../services/PaymentMethodService";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
    },
    form: {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        "& > *": {
            minWidth: "30%",
            margin: theme.spacing(1),
        },
    },
}));

const initialFeedback = {
    loading: false,
    hidden: true,
    severity: "success",
    message: "",
};

const AddPaymentMethod = ({ setPaymentMethodAdded }: any) => {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");

    const classes = useStyles();

    const [feedback, setFeedback] = useState(initialFeedback);

    async function handleSubmit(e: any) {
        e.preventDefault();
        setFeedback({ ...initialFeedback, loading: true });

        const [data, err] = await paymentMethodService.createPaymentMethod({
            name: name,
            description: description,
        });

        if (data) {
            setFeedback({
                loading: false,
                message: data.message,
                hidden: false,
                severity: "success",
            });
            setPaymentMethodAdded((n: number) => n + 1);
        } else {
            setFeedback({
                loading: false,
                message: err,
                hidden: false,
                severity: "error",
            });
        }
    }
    return (
        <Accordion className={classes.root}>
            <AccordionSummary>
                <Typography variant="h5">Create Payment Method</Typography>
            </AccordionSummary>
            <AccordionDetails
                style={{ display: "flex", flexDirection: "column" }}
            >
                {feedback.loading && <LinearProgress />}
                <section
                    hidden={feedback.hidden}
                    style={{ paddingBottom: "1rem" }}
                >
                    <Alert severity={feedback.severity as any}>
                        {feedback.message}
                    </Alert>
                </section>

                <Grid
                    container
                    spacing={2}
                    component="form"
                    onSubmit={handleSubmit}
                    style={{
                        maxWidth: "760px",
                        justifyContent: "center",
                        margin: "0 auto",
                    }}
                >
                    <Grid item xs={12}>
                        <TextField
                            name="name"
                            value={name}
                            onChange={(ev) => setName(ev.target.value)}
                            label="Payment method name"
                            required
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            name="description"
                            value={description}
                            onChange={(ev) => setDescription(ev.target.value)}
                            label="Description"
                            variant="outlined"
                            fullWidth
                            minRows={4}
                            multiline
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            style={{ height: "100%" }}
                            fullWidth
                            color="primary"
                            variant="outlined"
                            type="submit"
                            endIcon={
                                feedback.loading ? (
                                    <CircularProgress size="1.1rem" />
                                ) : (
                                    <Add />
                                )
                            }
                        >
                            Create Bank
                        </Button>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default AddPaymentMethod;
